import axios from "axios";
import { baseURL } from "./globals/constants";

// Admin sessions: the access token lives 30 minutes. When a call gets 401, the refresh token is used once to get
// a new pair and the call is repeated - so an active admin stays signed in, and an idle one (refresh token
// expired after 2 hours) is sent back to the login.
let refreshing: Promise<string | null> | null = null;

const refresh = async (): Promise<string | null> => {
  const refreshToken = localStorage.getItem("refresh_token");
  if (!refreshToken) return null;
  try {
    const response = await axios.post(`${baseURL}/v1/auth/refresh-tokens`, { refreshToken });
    localStorage.setItem("access_token", response.data.tokens.access.token);
    localStorage.setItem("refresh_token", response.data.tokens.refresh.token);
    return response.data.tokens.access.token;
  } catch {
    localStorage.removeItem("refresh_token");
    return null;
  }
};

export const startSessionRefresh = () => {
  axios.interceptors.response.use(undefined, async (error) => {
    const config = error?.config;
    const isAuthCall = String(config?.url || "").includes("/v1/auth/");
    if (error?.response?.status !== 401 || !config || config._retried || isAuthCall) {
      throw error;
    }
    refreshing = refreshing || refresh().finally(() => (refreshing = null));
    const token = await refreshing;
    if (!token) throw error;
    config._retried = true;
    config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
    return axios.request(config);
  });
};
